import { useTakeoverExperimentContext } from 'modules/experiments/contexts';
import { BlastSettings } from './BlastSettings';
import { TriggerSettings } from './TriggerSettings';
import { STOSettings } from './STOSettings';
import { SendTimeSettings } from './SendTimeSettings';

export const ReadOnlySettings = () => {
  const { isBlastCampaign, isTriggerCampaign, isSTOExperiment, isSendTimeExperiment } =
    useTakeoverExperimentContext();

  switch (true) {
    case isSendTimeExperiment:
      return <SendTimeSettings />;

    case isSTOExperiment:
      return <STOSettings />;

    case isBlastCampaign:
      return <BlastSettings />;

    case isTriggerCampaign:
      return <TriggerSettings />;

    default:
      return <></>;
  }
};
